export const VITAL_SIGNS = {
    masterTableName: "PATIENT_VITAL_RECORDS",
    tableName: "PATIENT_VITAL_RECORDS",
    columnName: "ID",
    columnValue: 0,
    withPtId: true,
    title: "patient-vital-records.title",
    rows: [
        { title: "id", value: "ID" },
        { title: "date", value: "CTIME", headerName: "Tarih" },
        { title: "patient", value: "PT_ID" },
        { title: "body_temperature", value: "BODY_TEMPERATURE" },
        { title: "meas_method_of_body_temp", value: "MEAS_METHOD_OF_BODY_TEMP" },
        { title: "heart_rate", value: "HEART_RATE" },
        { title: "heart_rate_type", value: "HEART_RATE_TYPE" },
        { title: "sys", value: "SYS" },
        { title: "dia", value: "DIA" },
        { title: "respiratory_count", value: "RESPIRATORY_COUNT" },
        { title: "respiratory_count_type", value: "RESPIRATORY_COUNT_TYPE" },
        { title: "respiratory_distress", value: "RESPIRATORY_DISTRESS" },
        { title: "siyoneze_circulation_disorder", value: "SIYONEZE_CIRCULATION_DISORDER" },
        { title: "is_taken_o2", value: "IS_TAKEN_O2" },
        { title: "o2_amount", value: "O2_AMOUNT" },
        { title: "o2_unit", value: "O2_UNIT" },
        { title: "level_of_consciousness", value: "LEVEL_OF_CONSCIOUSNESS" },
        { title: "pain_level", value: "PAIN_LEVEL" },
        { title: "defakasyon", value: "DEFAKASYON" },
        { title: "urine", value: "URINE" },
        { title: "early_warning_score", value: "EARLY_WARNING_SCORE" },
        { title: "write_on_epicrise", value: "WRITE_ON_EPICRISE" },
        { title: "upn", value: "UPN" },
        { title: "o2_saturuzation", value: "O2_SATURUZATION" },
        { title: "ptime", value: "PTIME" },
        { title: "capillary_circulation", value: "CAPILLARY_CIRCULATION" },
        { title: "birth_pain", value: "BIRTH_PAIN" },
        { title: "birth_losia", value: "BIRTH_LOSIA" },
        { title: "birth_proteinuria", value: "BIRTH_PROTEINURIA" },
        { title: "koah_saturation", value: "KOAH_SATURATION" },
        { title: "evaluation", value: "EVAULATION" },
    ],

    fields: [
        { field: "date", headerName: "datetime", flex: 1 },
        { field: "body_temperature", headerName: "vital.body-temperature", flex: 1 },
        { field: "heart_rate", headerName: "vital.heart-rate", flex: 1 },
        { field: "sys", headerName: "vital.sys", flex: 1 },
        { field: "dia", headerName: "vital.dia", flex: 1 },
        { field: "respiratory_count", headerName: "vital.respiratory-count", flex: 1 },
        { field: "o2_amount", headerName: "vital.o2-amount", flex: 1 },
        { field: "o2_saturuzation", headerName: "vital.o2-saturation", flex: 1 },
        { field: "pain_level", headerName: "vital.pain-level", flex: 1 },
        { field: "early_warning_score", headerName: "vital.ews", flex: 1 },
        { field: "evaluation", headerName: "vital.evaluation", flex: 1 },
    ],

    mcpConfig: {
        SIYONEZE_CIRCULATION_DISORDER: { mcpId: 20, field: "SIYONEZE_CIRCULATION_DISORDER", scoreField: "SIYONEZE_CIRCULATION_DISORDER" },
        DEFAKASYON: { mcpId: 22, field: "DEFAKASYON", scoreField: "DEFAKASYON" },
        URINE: { mcpId: 22, field: "URINE", scoreField: "URINE" },
        IS_TAKEN_O2: { mcpId: 21, field: "IS_TAKEN_O2", scoreField: "IS_TAKEN_O2" },
        MEAS_METHOD_OF_BODY_TEMP: { mcpId: 25, field: "MEAS_METHOD_OF_BODY_TEMP", scoreField: "MEAS_METHOD_OF_BODY_TEMP" },
        HEART_RATE_TYPE: { mcpId: 26, field: "HEART_RATE_TYPE", scoreField: "HEART_RATE_TYPE" },
        RESPIRATORY_COUNT_TYPE: { mcpId: 27, field: "RESPIRATORY_COUNT_TYPE", scoreField: "RESPIRATORY_COUNT_TYPE" },
        RESPIRATORY_DISTRESS: { mcpId: 28, field: "RESPIRATORY_DISTRESS", scoreField: "RESPIRATORY_DISTRESS" },
        O2_UNIT: { mcpId: 29, field: "O2_UNIT", scoreField: "O2_UNIT" },
        LEVEL_OF_CONSCIOUSNESS: { mcpId: 30, field: "LEVEL_OF_CONSCIOUSNESS", scoreField: "LEVEL_OF_CONSCIOUSNESS" },
        PAIN_LEVEL: { mcpId: 31, field: "PAIN_LEVEL", scoreField: "PAIN_LEVEL" },
        CAPILLARY_CIRCULATION: { mcpId: 747, field: "CAPILLARY_CIRCULATION", scoreField: "CAPILLARY_CIRCULATION" },
        BIRTH_PAIN: { mcpId: 907, field: "BIRTH_PAIN", scoreField: "BIRTH_PAIN" },
        BIRTH_LOSIA: { mcpId: 908, field: "BIRTH_LOSIA", scoreField: "BIRTH_LOSIA" },
        BIRTH_PROTEINURIA: { mcpId: 909, field: "BIRTH_PROTEINURIA", scoreField: "BIRTH_PROTEINURIA" },
        KOAH_SATURATION: { mcpId: 910, field: "KOAH_SATURATION", scoreField: "KOAH_SATURATION" },
        EVAULATION: { mcpId: 971, field: "EVAULATION", scoreField: "EVAULATION" },
    } as Record<string, { mcpId: number; field: string; scoreField: string }>,
    formData: {
        ID: null,
        CUSER: "",
        CTIME: new Date(),
        PT_ID: null,
        BODY_TEMPERATURE: "",
        MEAS_METHOD_OF_BODY_TEMP: "",
        HEART_RATE: "",
        HEART_RATE_TYPE: "",
        SYS: "",
        DIA: "",
        RESPIRATORY_COUNT: "",
        RESPIRATORY_COUNT_TYPE: "",
        RESPIRATORY_DISTRESS: "",
        SIYONEZE_CIRCULATION_DISORDER: "",
        IS_TAKEN_O2: "",
        O2_AMOUNT: "",
        O2_UNIT: "",
        LEVEL_OF_CONSCIOUSNESS: "",
        PAIN_LEVEL: "",
        DEFAKASYON: "",
        URINE: "",
        EARLY_WARNING_SCORE: "",
        WRITE_ON_EPICRISE: "",
        UPN: "",
        O2_SATURUZATION: "",
        PTIME: new Date(),
        CAPILLARY_CIRCULATION: "",
        BIRTH_PAIN: "",
        BIRTH_LOSIA: "",
        BIRTH_PROTEINURIA: "",
        KOAH_SATURATION: "",
        EVAULATION: "",
    },
    chartScoreField: "EARLY_WARNING_SCORE",
    chartTimeField: "CTIME",
};
